<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    isSmall?: boolean
    status: 'error' | 'help' | 'info' | 'success' | 'warning'
  }>(),
  { isSmall: false }
)

const classes = computed(() => {
  switch (props.status) {
    case 'error':
      return 'before:bg-main-red text-main-red bg-main-red/10'
    case 'help':
      return 'before:bg-main-blue text-main-blue bg-main-blue/10'
    case 'info':
      return 'before:bg-main-blue text-main-blue bg-main-blue/10'
    case 'success':
      return 'before:bg-main-green text-main-green bg-main-green/10'
    case 'warning':
      return 'before:bg-main-orange text-main-orange bg-main-orange/10'
    default:
      return null
  }
})
</script>

<template>
  <div
    class="
      relative inline-flex overflow-hidden
      before:absolute before:left-0 before:top-0 before:h-full before:w-1.5 before:content-['']
    "
    :class="[classes, props.isSmall ? 'rounded-xl px-4 py-1.5' : 'rounded-xl px-4 py-2']"
  >
    <slot />
  </div>
</template>
